var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 10.845l-8.983 9.363c-2.291 2.39-6.007 2.39-8.298 0-2.292-2.388-2.292-6.261 0-8.65L11.7 2.194a3.8 3.8 0 0 1 5.533 0c1.528 1.593 1.528 4.175 0 5.767L8.24 17.325a1.9 1.9 0 0 1-2.766 0 2.1 2.1 0 0 1 0-2.884l8.299-8.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/Paperclip.eff7f7afd0d2cf7d46dc09b40dba9279.svg";
export { ForwardRef as ReactComponent };